import * as React from 'react';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-date-range.css';
var getClassNameList = classNames.bind(styles);
var UitkDateRangeButton = function (_a) {
  var _b;
  var className = _a.className,
    result = _a.result;
  var accessibilityMessage = result.accessibilityMessage,
    analytics = result.analytics,
    dateText = result.dateText,
    onClickCallback = result.onClickCallback,
    _c = result.selected,
    selected = _c === void 0 ? false : _c,
    text = result.text,
    textTheme = result.textTheme;
  var onClickCapture = function () {
    analytics && analyticsTracker(analytics);
    onClickCallback && onClickCallback();
  };
  var buttonClassNames = getClassNameList(className, (_b = {},
  // eslint-disable-next-line no-useless-computed-key
  _b['selected'] = selected, _b["".concat(textTheme)] = textTheme, _b));
  return React.createElement("button", {
    type: "button",
    "aria-selected": selected,
    "aria-label": accessibilityMessage,
    className: buttonClassNames,
    onClickCapture: onClickCapture,
    role: "tab"
  }, React.createElement("span", {
    className: getClassNameList("".concat(className, "-date-text"))
  }, dateText), React.createElement("span", {
    className: getClassNameList("".concat(className, "-text"))
  }, text));
};
export { UitkDateRangeButton };